<button class="btn btn-outline-primary float-right ml-2" (click)="verHistorico()">
  <i class="fa fa-history mr-2"></i>Histórico de Pausas
</button>


<button class="btn btn-blue float-right" (click)="novaPausa()" > Nova Pausa Programada</button>


<div class="d-flex justify-content-between mb-3">


</div>

<div class="clearfix"></div>

<div class="alert alert-info mt-2 text-center" role="alert" *ngIf="!empresa.pausasProgramadas.length">
  <button type="button" class="close" data-dismiss="alert" aria-label="Fechar">
    <span aria-hidden="true">&times;</span>
  </button>
  <i class="fa fa-clock fa-lg mr-2"></i>
  Nenhuma pausa programada
</div>


<div class="mt-2"  *ngFor="let mes of mesesProgramados">
  <h3><i class="fa fa-calendar-alt mr-2"></i> {{mes}}</h3>
  <div class="card-box cpointer" *ngFor="let pausaProgramada of obtenhaPausasDoMes(mes)" (click)="editarPausa(pausaProgramada)"
   [hidden]="pausaProgramada.removida" [ngClass]="{'ativa' : pausaProgramada.agora}">
    <div class="row">
      <div class="col-12 text-right mb-2">
        <button class="btn btn-link text-danger btn-remover"
                kendoTooltip
                title="Remover pausa programada"
                (click)="confirmarRemocao($event, pausaProgramada)">
          <i class="fa fa-trash fa-lg"></i>
        </button>
      </div>
      <div class="col-6">
        <h4> {{pausaProgramada.descricao}}</h4>
        <p class="text-muted">
          Indisponível por {{obtenhaTempoIndisponivel(pausaProgramada)}}
        </p>
      </div>
      <div class="col-6">
        <div class="row" style="width: 250px;">
          <div class="col">
            {{pausaProgramada.dataInicio | date: "dd/MM/yyyy"}}
            <br>
            <span class="text-muted">
              De {{pausaProgramada.dataInicio | date: "HH:mm"}}
           </span>

            <i class="fa fa-arrow-right fa-lg" style="position: relative;right: -30px;top: -10px;"></i>
          </div>

          <div class="col">
            {{pausaProgramada.dataFim | date: "dd/MM/yyyy"}}   <br>
            <span class="text-muted">
                Até {{pausaProgramada.dataFim | date: "HH:mm"}}
             </span>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<!-- Modal de Confirmação -->
<kendo-dialog *ngIf="modalConfirmacao" [width]="500" [height]="300" (close)="fecharModal()">
  <kendo-dialog-titlebar>
    <i class="fa fa-exclamation-triangle text-warning mr-2"></i>
    Confirmar Remoção
  </kendo-dialog-titlebar>

  <div class="p-4" style="padding-top: 0 !important;">
    <p class="mb-3">Tem certeza que deseja remover esta pausa programada?</p>

    <div class="alert alert-light border">
      <h5 class="mb-2 mt-0">{{pausaParaRemover?.descricao}}</h5>
      <p class="mb-0">
        <i class="fa fa-calendar-alt mr-2"></i>
        {{pausaParaRemover?.dataInicio | date: "dd/MM/yyyy HH:mm"}}

        <span *ngIf="pausaParaRemover?.dataFim">
            até
          {{pausaParaRemover?.dataFim | date: "dd/MM/yyyy HH:mm"}}
          {{pausaParaRemover?.dataFim | date: ""}}
        </span>

      </p>
    </div>
  </div>

  <kendo-dialog-actions>
    <button class="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base" (click)="fecharModal()">
      <i class="fa fa-times mr-2"></i>Cancelar
    </button>
    <button class="k-button k-button-md k-rounded-md k-button-solid k-button-solid-error" [disabled]="   this.pausaParaRemover.removendo "
            (click)="removerPausa()">
      <i class="fa fa-trash mr-2" [hidden]="this.pausaParaRemover.removendo"></i>
      <i class="k-icon k-i-loading" *ngIf="this.pausaParaRemover.removendo"></i>
      Remover
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
